import React, { Suspense } from "react";
import { renderRoutes } from "react-router-config";
import PropTypes from "prop-types";

//import Sidebar from "./Components/Sidebar/Sidebar";

const Guest = (props) => {
  const {
    route,
  } = props;

  return (
    <div>
      
      {/* <Sidebar props={props} /> */}
      <Suspense>
        {renderRoutes(route.routes)}

      </Suspense >
    </div>
  );
};

Guest.propTypes = {
  route: PropTypes.object,
};

export default Guest;
